module.exports = __webpack_public_path__ + "static/media/ASA.737f4557.svg";